<template>
  <div id="widget-builder-large">
    <p class="widget-instructions">
      {{ $t("widget_details.step_2") }}
    </p>
    <p>
      {{ $t("widget_details.builder_link1") }}
      <a @click="scrollMeTo('custom_attributes')">{{
        $t("widget_details.builder_link2")
      }}</a
      >{{ $t("widget_details.builder_link3") }}
    </p>

    <br />
    <div class="columns">
      <div class="column is-12">
        <div class="card widget-options">
          <div class="columns">
            <div class="column is-5">
              <!-- html code box -->

              <div class="card-content">
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.html_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.html_title") }}
                    </legend>
                  </b-tooltip>
                </fieldset>

                <div class="is-block widget-code">
                  <div class="html-code" ref="text">
                    &lt;{{ widget.tag }}
                    <br />
                    <div v-if="widgetForm.selectedLanguage != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;lang="{{
                        widgetForm.selectedLanguage
                      }}"
                    </div>
                    <div v-if="widgetForm.selectedLanguage === null">
                      &nbsp;&nbsp;&nbsp;&nbsp;lang="{{ langChange }}"
                    </div>
                    <div v-if="widgetForm.multipleSelection != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;multiple="{{
                        widgetForm.multipleSelection
                      }}"
                    </div>
                    <div v-if="widgetForm.selectedInputs != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;show-inputs="{{
                        widgetForm.selectedInputs
                      }}"
                    </div>
                    <div v-if="widgetForm.label != ''">
                      &nbsp;&nbsp;&nbsp;&nbsp;label="{{ widgetForm.label }}"
                    </div>
                    <div v-if="widgetForm.naicsCode != false">
                      &nbsp;&nbsp;&nbsp;&nbsp;naics-code="{{
                        widgetForm.naicsCode
                      }}"
                    </div>
                    <div v-if="widgetForm.sgcCode != false">
                      &nbsp;&nbsp;&nbsp;&nbsp;sgc-code="{{
                        widgetForm.sgcCode
                      }}"
                    </div>
                    <div v-if="widgetForm.selectedCompare != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;show-compare="{{
                        widgetForm.selectedCompare
                      }}"
                    </div>
                    <div v-if="widgetForm.naicsCompare != false">
                      &nbsp;&nbsp;&nbsp;&nbsp;naics-compare="{{
                        widgetForm.naicsCompare
                      }}"
                    </div>
                    <div v-if="widgetForm.sgcCompare != false">
                      &nbsp;&nbsp;&nbsp;&nbsp;sgc-compare="{{
                        widgetForm.sgcCompare
                      }}"
                    </div>
                    <div v-if="widgetForm.showCode != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;show-code="{{
                        widgetForm.showCode
                      }}"
                    </div>
                    <div v-if="widgetForm.showResults != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;show-results="{{
                        widgetForm.showResults
                      }}"
                    </div>
                    <div v-if="widgetForm.levelSelectable != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;level-selectable="{{
                        widgetForm.levelSelectable.toString()
                      }}"
                    </div>
                    &gt;&lt;/{{ widget.tag }}&gt;
                  </div>
                  <ButtonCopy class="is-small is-pulled-right"></ButtonCopy>
                </div>
              </div>
            </div>
            <!-- widget options form box -->
            <div class="column is-7 triangle-left-large column-dark">
              <div class="card-content">
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    type="is-light"
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.options_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.component_options") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <!-- form start -->
                <form id="widget-form" class="widget-form">
                  <!-- language select -->
                  <b-field
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.language_label')"
                    label-for="language-select"
                  >
                    <b-select
                      id="language-select"
                      expanded
                      v-model="widgetForm.selectedLanguage"
                      :placeholder="$t('form_options.placeholder_lang')"
                    >
                      <option
                        v-for="option of $t('form_options.languageOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- multiple select -->
                  <b-field
                    v-if="widget.id == '4'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.selection_label')"
                    label-for="multiple-select"
                  >
                    <b-select
                      id="multiple-select"
                      expanded
                      v-model="widgetForm.multipleSelection"
                      :placeholder="$t('form_options.placeholder_multiple')"
                    >
                      <option
                        v-for="option of $t('form_options.selectionOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- custom table label input -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                    :label="
                      widget.id == '4'
                        ? $t('form_fields.button_label')
                        : $t('form_fields.table_label')
                    "
                    label-for="field-label"
                  >
                    <b-input
                      id="field-label"
                      v-model="widgetForm.label"
                      :placeholder="
                        widget.id == '4'
                          ? $t('form_fields.placeholder_button_label')
                          : $t('form_fields.placeholder_table_label')
                      "
                    ></b-input>
                  </b-field>
                  <!-- custom button label input -->
                  <b-field
                    v-if="widget.id == '4'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.button_label')"
                    label-for="button-label"
                  >
                    <b-input
                      id="button-label"
                      v-model="widgetForm.label"
                      :placeholder="$t('form_fields.placeholder_button_label')"
                    ></b-input>
                  </b-field>
                  <!-- show inputs select -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                  >
                    <template slot="label" label-for="show-inputs">
                      {{ $t("form_fields.show_inputs_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_show_inputs')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-select
                      id="show-inputs"
                      expanded
                      v-model="widgetForm.selectedInputs"
                      :placeholder="$t('form_options.placeholder_show_inputs')"
                    >
                      <option
                        v-for="option of $t('form_options.showInputsOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- naics-code input -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                  >
                    <template slot="label" label-for="naics-code">
                      {{ $t("form_fields.naics_code_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_naics_code')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-input
                      id="naics-code"
                      v-model="widgetForm.naicsCode"
                      :placeholder="$t('form_fields.placeholder_naics_code')"
                    ></b-input>
                  </b-field>
                  <!-- sgc-code input -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                  >
                    <template slot="label" label-for="sgc-code">
                      {{ $t("form_fields.sgc_code_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_sgc_code')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-input
                      id="sgc-code"
                      v-model="widgetForm.sgcCode"
                      :placeholder="$t('form_fields.placeholder_sgc_code')"
                    ></b-input>
                  </b-field>
                  <!-- show compare select -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.show_compare_label')"
                    label-for="show-compare"
                  >
                    <b-select
                      id="show-compare"
                      expanded
                      v-model="widgetForm.selectedCompare"
                      :placeholder="$t('form_options.placeholder_show_compare')"
                    >
                      <option
                        v-for="option of $t('form_options.showCompareOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- naics-code compare input -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                  >
                    <template slot="label" label-for="naics-compare">
                      {{ $t("form_fields.naics_compare_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_naics_compare_code')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-input
                      id="naics-compare"
                      v-model="widgetForm.naicsCompare"
                      :placeholder="$t('form_fields.placeholder_naics_code')"
                    ></b-input>
                  </b-field>
                  <!-- sgc-code compare input -->
                  <b-field
                    v-if="widget.id == '3'"
                    horizontal
                    class="op-large-builder"
                  >
                    <template slot="label" label-for="sgc-compare">
                      {{ $t("form_fields.sgc_compare_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_sgc_compare_code')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-input
                      id="sgc-compare"
                      v-model="widgetForm.sgcCompare"
                      :placeholder="$t('form_fields.placeholder_sgc_code')"
                    ></b-input>
                  </b-field>
                  <!-- show code select -->
                  <b-field
                    v-if="widget.id == '4'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.show_code_label')"
                    label-for="show-code"
                  >
                    <b-select
                      id="show-code"
                      expanded
                      v-model="widgetForm.showCode"
                      :placeholder="$t('form_options.placeholder_show_code')"
                    >
                      <option
                        v-for="option of $t('form_options.showOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- show results select -->
                  <b-field
                    v-if="widget.id == '4'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.show_results_label')"
                    label-for="show-results"
                  >
                    <b-select
                      id="show-results"
                      expanded
                      v-model="widgetForm.showResults"
                      :placeholder="$t('form_options.placeholder_show_results')"
                    >
                      <option
                        v-for="option of $t('form_options.resultsOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- NAICS level select -->
                  <b-field
                    v-if="widget.id == '4'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.naics_level_label')"
                    label-for="naics-level-select"
                  >
                    <b-select
                      id="naics-level-select"
                      expanded
                      v-model="widgetForm.levelSelectable"
                      :placeholder="$t('form_options.placeholder_naics_level')"
                    >
                      <option
                        v-for="option of $t('form_options.naicsLevelOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!--   <b-field
                    v-if="widget.id == '4'"
                    horizontal
                    class="op-large-builder"
                    :label="$t('form_fields.naics_level_label')"
                    label-for="naics-level-select"
                  >
                    <b-dropdown expanded multiple id="naics-level-select">
                      <template #trigger>
                        <b-button
                          class="op-large-builder-dropdown"
                          expanded
                          :label="$t('form_options.placeholder_naics_level')"
                          :icon-right="'chevron-down'"
                        >
                        </b-button>
                      </template>
                      <b-dropdown-item custom aria-role="listitem">
                        <b-checkbox
                          @click.native="
                            (isDisabled = !isDisabled),
                              (widgetForm.levelSelectable = [])
                          "
                          v-model="widgetForm.levelSelectable1"
                          v-for="option of $t(
                            'form_options.naicsLevelOptions1'
                          )"
                          :native-value="option.value"
                          :key="option.id"
                        >
                          {{ option.text }}
                        </b-checkbox>
                      </b-dropdown-item>
                      <b-dropdown-item custom aria-role="listitem">
                        <b-checkbox
                          :disabled="isDisabled"
                          v-model="widgetForm.levelSelectable"
                          v-for="option of $t('form_options.naicsLevelOptions')"
                          :native-value="option.value"
                          :key="option.id"
                        >
                          {{ option.text }}
                        </b-checkbox>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-field> -->

                  <!-- reset button -->
                  <b-button
                    @click="resetForm()"
                    class="is-light is-pulled-right"
                  >
                    {{ $t("form_fields.reset") }}
                  </b-button>
                </form>
              </div>
              <div class="card-content">
                <a
                  id="custAttLink"
                  tabindex="0"
                  @keyup.enter="onEnter"
                  class="docs-link2 is-pulled-right"
                  @click="scrollMeTo('custom_attributes')"
                >
                  {{ $t("widget_details.custom_attributes_docs") }}
                </a>
              </div>
            </div>
          </div>

          <div class="card-content">
            <!-- live example box -->

            <fieldset class="subtitle form">
              <b-tooltip
                multilined
                size="is-large"
                position="is-right"
                :label="$t('form_fields.example_tooltip')"
              >
                <legend>
                  {{ $t("form_fields.example_title") }}
                </legend>
              </b-tooltip>
            </fieldset>

            <div class="card-content live-example-large">
              <component
                :is="widget.tag"
                :lang="langChange"
                :multiple="multipleChange"
                :label="labelChange"
                :naics-code="naicsChange"
                :sgc-code="sgcChange"
                :naics-compare="naicsCompareChange"
                :sgc-compare="sgcCompareChange"
                :compare-option="showCompareChange"
                :show-inputs="showInputsChange"
                :show-code="showcodeChange"
                :show-results="showResultsChange"
                @change="changeCallback"
                :level-selectable="naicsLevelChange"
              >
              </component>
            </div>
          </div>
        </div>

        <!-- end div column 12 -->
      </div>
    </div>
  </div>
</template>
<script>
import ButtonCopy from "./ButtonCopy.vue";
export default {
  name: "WidgetBuilderLarge",
  props: {
    widget: { type: Object, required: true },
    lang: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    showInputs: {
      type: Boolean
    },
    label: {
      type: String
    },
    naicsCode: {
      type: String
    },
    sgcCode: {
      type: String
    },
    naicsCompare: {
      type: String
    },
    sgcCompare: {
      type: String
    },
    compareOption: {
      type: Boolean
    },
    showCode: {
      type: Boolean
    },
    levelSelectable: {
      type: String
    },
    showResults: {
      type: String
    }
  }, // end props
  data: function() {
    return {
      defaultShowInputs: true,
      defaultCompareOption: true,
      defaultShowCode: true,
      defaultNaicsLevel: "2",
      toggle: false,
      defaultShowResults: "",
      defaultMultiple: false,
      defaultNaicsLevels: "2",
      isDisabled: false,
      //isChecked: "checked",
      selectedData: [], // Must be an array reference
      widgetForm: {
        selectedLanguage: null,
        multipleSelection: null,
        selectedInputs: null,
        selectedCompare: null,
        label: "",
        callback: "",
        naicsCode: "",
        sgcCode: "",
        naicsCompare: "",
        sgcCompare: "",
        showCode: null,
        levelSelectable: null,
        showResults: null
      },
      results: null
    };
  }, // end data
  components: {
    ButtonCopy
  }, // end components
  computed: {
    langChange: function() {
      if (this.widgetForm.selectedLanguage === null) {
        return this.$i18n.locale;
      } else {
        return this.widgetForm.selectedLanguage;
      }
    },
    multipleChange: function() {
      if (this.widgetForm.multipleSelection === null) {
        return this.defaultMultiple;
      } else {
        return this.widgetForm.multipleSelection;
      }
    },
    showInputsChange: function() {
      if (this.widgetForm.selectedInputs === null) {
        return this.defaultShowInputs;
      } else {
        return this.widgetForm.selectedInputs;
      }
    },
    showCompareChange: function() {
      if (this.widgetForm.selectedCompare === null) {
        return this.defaultShowCompare;
      } else {
        return this.widgetForm.selectedCompare;
      }
    },
    labelChange: function() {
      return this.widgetForm.label;
    },
    naicsChange: function() {
      return this.widgetForm.naicsCode;
    },
    sgcChange: function() {
      return this.widgetForm.sgcCode;
    },
    naicsCompareChange: function() {
      return this.widgetForm.naicsCompare;
    },
    sgcCompareChange: function() {
      return this.widgetForm.sgcCompare;
    },
    showcodeChange: function() {
      if (this.widgetForm.showCode === null) {
        return this.defaultShowCode;
      } else {
        return this.widgetForm.showCode;
      }
    },
    naicsLevelChange: function() {
      if (this.widgetForm.levelSelectable === null) {
        return this.defaultNaicsLevels;
      } else {
        return this.widgetForm.levelSelectable;
      }
    },
    showResultsChange: function() {
      if (this.widgetForm.showResults === null) {
        return this.defaultShowResults;
      } else {
        return this.widgetForm.showResults;
      }
    }
  }, // end computed
  methods: {
    scrollMeTo: function(refName) {
      var element = this.$parent.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    },
    changeCallback: function(event) {
      this.results = null;
      this.results = event;
    }, //end changeCallback
    resetForm: function() {
      this.widgetForm.selectedLanguage = null;
      this.widgetForm.multipleSelection = null;
      this.widgetForm.label = "";
      this.widgetForm.selectedInputs = null;
      this.widgetForm.naicsCode = "";
      this.widgetForm.sgcCode = "";
      this.widgetForm.selectedCompare = null;
      this.widgetForm.naicsCompare = "";
      this.widgetForm.sgcCompare = "";
      this.widgetForm.showCode = null;
      this.widgetForm.levelSelectable = [];
      this.widgetForm.showResults = null;
    }
  } // end methods
};
</script>

<style lang="scss">
.subtitle.form {
  min-width: 100%;
  margin-bottom: 24px;
}
.widget-options {
  padding: 12px;
  border-radius: 0.5rem;
  background: #f0f9ff;
  box-shadow: none;
  margin-bottom: 30px;
}
/* slide animation */
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

/* form css */
form.widget-form {
  .select,
  .input {
    font-size: 15px;
  }
}
.control-label {
  min-width: 8rem;
  color: #274f6e;
}
.label {
  color: #274f6e;
}
.products-checkbox {
  margin-top: 4px;
}
.related-data {
  padding-top: 24px;
}
.data-label .control-label {
  padding-top: 4px;
  padding-bottom: 4px;
}
.field.is-grouped {
  margin-bottom: 2px;
}
.html-code {
  //padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 16px;
  color: #274f6e;
  font-family: monospace;
}
.has-text-left {
  font-weight: 400;
}
.form-control {
  max-width: 195px !important;
}
form.widget-form .form-control {
  width: inherit !important;
}
form.widget-form select.form-control[size],
select.form-control[multiple] {
  height: 37px;
  max-width: 195px;
}
.b-checkbox.checkbox input[type="checkbox"] + .check {
  border: 2px solid #274f6e;
}
.button-html {
  padding-top: 16px;
  padding-bottom: 12px;
}
// overwrite placehoder for b-select
// not enough contrast
.select.is-empty select {
  color: #737373;
}
.triangle-left-large {
  border-style: solid;
  border-radius: 10% 0% 0% 10%;
  border-color: #274f6e;
}
/* live widget css */
.live-example-large {
  min-height: 460px;
  justify-content: center;
  background: #fff;
  margin: 0 0px 0 0px;
  border-radius: 5px;
  padding: 40px 40px 50px 40px;
  border: 1px dashed #274f6e;
  .field-label.is-normal {
    padding: 0px;
  }
}
.vs__dropdown-menu {
  max-width: inherit !important;
  flex-grow: 0 !important;
}
.vs__dropdown-toggle {
  background: white !important;
}
.column-dark {
  background: #274f6e;
  label,
  legend {
    color: #fff;
  }
}
.widget-code {
  background: transparent;
  position: relative;
  clear: left;
  padding: 0 20px 16px 20px;
}

.docs-link2 {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: underline;
}

.docs-link2:hover,
.docs-link2focus {
  color: rgba(255, 255, 255, 1);
}
/* 
.inlineRight {
  display: none;
} */

@media screen and (min-width: 769px), print {
  .op-large-builder .field-label {
    flex-grow: 4; /* overwrites previous value of 1 */
  }
  .field.is-horizontal {
    align-items: center;
  }
}
@media screen and (max-width: 416px) {
  .is-pulled-right {
    font-size: 80%;
  }
  .widget-code {
    max-width: 240px;
    padding: 10px;
  }
  .column.is-7 {
    padding-left: 4px;
  }
  #nocs_codes.input {
    max-width: 96px;
    font-size: 80%;
  }
  #hs_codes.input {
    max-width: 96px;
    font-size: 80%;
  }
  .input-box-bottom {
    margin-left: 0px;
  }
  .field.data-label {
    margin-right: 4px !important;
    .label {
      font-size: 80%;
      max-width: 96px;
    }
  }
  .field.hidden-label .label {
    font-size: 80%;
    max-width: 96px;
  }
  .products-checkbox {
    margin-right: 4px !important;
  }
}
</style>
